import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFooterComponent } from './table-footer.component';

@NgModule({
  declarations: [TableFooterComponent],
  imports: [CommonModule],
  exports: [TableFooterComponent]
})
export class TableFooterModule {}
